import { Card } from "../components/ui/card";
import { PageHeader } from "../components/AppLayout";

const MODULOS = [
  {
    titulo: "Propiedad",
    nota: "Catálogo de inmuebles. Fuente para fichas, comparador y asistente.",
    campos: [
      ["id", "string", "Identificador único"],
      ["titulo", "string", "Ej: 'Departamento 3 amb. en Palermo'"],
      ["direccion", "string", "Calle y número"],
      ["barrio", "'Palermo' | 'Caballito' | 'Villa Crespo' | 'Belgrano'", "Barrio CABA"],
      ["tipo", "'Departamento' | 'PH' | 'Monoambiente' | 'Casa'", ""],
      ["operacion", "'Alquiler' | 'Venta'", ""],
      ["ambientes / dormitorios / banos", "number", ""],
      ["m2 / m2Cubiertos", "number", "Superficie total y cubierta"],
      ["antiguedad", "number", "Años"],
      ["precio", "number", "Pesos (alquiler) o USD (venta)"],
      ["moneda", "'ARS' | 'USD'", ""],
      ["expensas", "number", "Pesos mensuales"],
      ["cochera / mascotas / disponible", "boolean", ""],
      ["estadoOcupacion", "'Ocupado' | 'Libre'", "Define el flujo de visita"],
      ["amenities", "string[]", "Ej: ['Pileta','SUM']"],
      ["requisitos", "string", "Garantía, ingresos, etc."],
      ["imagen", "string (url)", ""],
      ["agenteId", "string → Agente.id", "Agente responsable"],
    ],
  },
  {
    titulo: "Agente",
    nota: "Los 3 agentes de la inmobiliaria (configurable).",
    campos: [
      ["id", "string", ""],
      ["nombre / email / telefono", "string", ""],
      ["color", "string (hex)", "Color en la agenda"],
    ],
  },
  {
    titulo: "Contrato",
    nota: "Contrato de alquiler. Base de cobros, ajustes y liquidaciones.",
    campos: [
      ["id", "string", ""],
      ["propiedadId", "string → Propiedad.id", ""],
      ["inquilino / propietario", "{ nombre, email, telefono }", "Datos de contacto"],
      ["montoMensual", "number", "Pesos"],
      ["indice", "'ICL' | 'IPC' | 'Fijo'", "Índice de ajuste"],
      ["ajustePct", "number", "% de ajuste estimado"],
      ["periodicidadAjusteMeses", "number", "3, 4, 6 o 12"],
      ["proximaActualizacion", "ISODate", ""],
      ["proximoMontoEstimado", "number", "Monto post-ajuste"],
      ["inicio / vencimiento", "ISODate", ""],
      ["estado", "'Vigente' | 'Por vencer' | 'En salida' | 'Finalizado'", ""],
      ["depositoMeses", "number", ""],
      ["diaPago", "string", "Ej: 'del 1 al 10'"],
      ["situacion", "string", "Ej: 'Al día', 'Con atraso', 'En salida'"],
    ],
  },
  {
    titulo: "DetalleContrato (ficha completa)",
    nota: "Se deriva del contrato y sus movimientos: condiciones, costos, cuenta corriente, check-in/out, arreglos, línea de tiempo y documentos.",
    campos: [
      ["plazo", "{ inicio, fin, duracionMeses, diasParaVencer }", "ISODate"],
      ["pago", "{ diaPago, punitorios }", "Punitorios por mora"],
      ["garantia", "{ tipo, datos }", "Propietaria / caución / recibo"],
      ["deposito", "{ monto, estado }", "Retenido / A devolver / Devuelto"],
      ["historialAjustes", "{ fecha, indice, pct, montoAnterior, montoNuevo }[]", ""],
      ["costos", "{ expensasOrdinarias, expensasExtraordinarias, abl, servicios[], seguroDepto, honorarios, desgloseInquilino, totalMensualInquilino }", "Quién paga y si está al día"],
      ["cuentaCorriente", "{ periodo, cobrado, debe, punitorios, arreglos, saldo, estado }[]", "Mes a mes"],
      ["saldoActual", "number", "Suma de deuda + punitorios + arreglos"],
      ["checkin", "{ fecha, llaves, medidores, inventario[] }", "Acta de entrada"],
      ["checkout", "{ aviso, fechaPrevista, inspeccion[], devolucion } | null", "Solo en salida/finalizado"],
      ["arreglos", "ArregloMantenimiento[]", "Ver abajo"],
      ["timeline", "{ fecha, tipo, texto }[]", "Firma, entrada, pagos, ajustes, arreglos, avisos, salida"],
      ["documentos", "{ id, nombre, tipo }[]", "PDFs de ejemplo"],
    ],
  },
  {
    titulo: "ArregloMantenimiento",
    nota: "Arreglo de la unidad con flujo de aprobación del propietario e imputación del costo.",
    campos: [
      ["id", "string", ""],
      ["titulo / ambiente", "string", ""],
      ["fechaReporte", "ISODate", ""],
      ["urgencia", "'Alta' | 'Media' | 'Baja'", ""],
      ["paga", "'Inquilino' | 'Propietario'", ""],
      ["presupuesto", "number", ""],
      ["aprobacion", "'Pendiente' | 'Aprobado' | 'Rechazado'", ""],
      ["proveedor", "string", ""],
      ["estado", "'Reportado' | 'Presupuestado' | 'Aprobado' | 'En curso' | 'Terminado'", ""],
      ["fotos", "{ antes, despues }", ""],
    ],
  },
  {
    titulo: "Cobro",
    nota: "Cobro del mes por contrato.",
    campos: [
      ["id", "string", ""],
      ["contratoId", "string → Contrato.id", ""],
      ["inquilino / direccion", "string", "Desnormalizado para la tabla"],
      ["periodo", "string", "Ej: 'Mes en curso'"],
      ["monto", "number", ""],
      ["vencimiento", "ISODate", ""],
      ["estado", "'Pagado' | 'Pendiente' | 'Atrasado'", ""],
      ["fechaPago", "ISODate | null", ""],
      ["recordatorioWhatsApp", "boolean", "Si corresponde enviar recordatorio"],
    ],
  },
  {
    titulo: "Reclamo (mantenimiento)",
    nota: "Reporte del inquilino, se asigna y se sigue hasta cerrar.",
    campos: [
      ["id", "string", ""],
      ["contratoId", "string → Contrato.id", ""],
      ["categoria", "'Plomería' | 'Electricidad' | 'Climatización' | 'Cerrajería' | 'Humedad' | 'Ascensor'", ""],
      ["titulo / descripcion", "string", ""],
      ["prioridad", "'Alta' | 'Media' | 'Baja'", ""],
      ["estado", "'Abierto' | 'Asignado' | 'En curso' | 'Cerrado'", ""],
      ["asignadoA", "string | null", "Proveedor o agente"],
      ["fechaReporte / fechaCierre", "ISODate | null", ""],
    ],
  },
  {
    titulo: "Conversacion (Asistente 24/7)",
    nota: "Conversación de WhatsApp o web atendida por el asistente.",
    campos: [
      ["id", "string", ""],
      ["canal", "'WhatsApp' | 'Web'", ""],
      ["contacto", "{ nombre, telefono }", ""],
      ["propiedadId", "string → Propiedad.id", "Propiedad consultada"],
      ["fueraDeHorario", "boolean", "Respondida con la oficina cerrada"],
      ["tomada", "boolean", "Un agente la tomó a mano"],
      ["agenteId", "string | null", ""],
      ["estado", "'Respondida por asistente' | 'Tomada por agente'", ""],
      ["ultimaActividad / horaActividad", "ISODate / string", ""],
      ["mensajes", "{ de:'cliente'|'bot'|'agente', texto, hora }[]", ""],
      ["ofrecioVisita", "boolean", ""],
    ],
  },
  {
    titulo: "Visita",
    nota: "Coordinación de visitas (ocupado = franjas + confirmación a tres).",
    campos: [
      ["id", "string", ""],
      ["propiedadId", "string → Propiedad.id", ""],
      ["interesado", "{ nombre, telefono }", ""],
      ["agenteId", "string → Agente.id", ""],
      ["tipo", "'Depto ocupado' | 'Depto libre'", ""],
      ["estado", "'Propuesta' | 'Confirmada' | 'Reprogramada' | 'Realizada'", ""],
      ["fecha / hora", "ISODate / string", ""],
      ["franjasPropuestas", "{ dia, rango, elegida }[]", "Marcadas por el inquilino"],
      ["confirmaciones", "{ interesado, inquilino, agente }", "Confirmación a tres"],
      ["recordatorioEnviado", "boolean", ""],
    ],
  },
  {
    titulo: "Interesado (lead)",
    nota: "Seguimiento: quién preguntó qué, última interacción, próximo paso.",
    campos: [
      ["id", "string", ""],
      ["nombre / telefono / email", "string", ""],
      ["propiedadId", "string → Propiedad.id", ""],
      ["origen", "'WhatsApp' | 'Portal web' | 'Zonaprop' | 'Referido' | 'Cartel'", ""],
      ["estado", "'Nuevo' | 'Contactado' | 'Visita agendada' | 'En negociación' | 'Cerrado'", ""],
      ["ultimaInteraccion", "ISODate", ""],
      ["proximoPaso", "string", ""],
      ["historial", "{ fecha, evento }[]", "Línea de tiempo"],
    ],
  },
  {
    titulo: "EventoAgenda",
    nota: "Evento de la agenda semanal por agente.",
    campos: [
      ["id", "string", ""],
      ["tipo", "'Visita' | 'Firma' | 'Vencimiento' | 'Tarea'", ""],
      ["titulo", "string", ""],
      ["diaSemana", "number (0=lunes … 6=domingo)", ""],
      ["hora", "number (8–18)", ""],
      ["fecha", "ISODate", ""],
      ["agenteId / agenteNombre", "string", ""],
    ],
  },
  {
    titulo: "Liquidacion",
    nota: "Liquidación mensual al propietario (se exporta a PDF).",
    campos: [
      ["id", "string", ""],
      ["contratoId", "string → Contrato.id", ""],
      ["propietario / inquilino / direccion", "string", ""],
      ["periodo", "string", ""],
      ["montoAlquiler", "number", ""],
      ["gastos", "{ concepto, monto }[]", "Montos negativos = descuentos"],
      ["neto", "number", "A transferir al propietario"],
    ],
  },
  {
    titulo: "ConfiguracionMarca (marca blanca)",
    nota: "Estado de marca blanca. En la demo vive en localStorage.",
    campos: [
      ["nombre", "string", "Nombre de la inmobiliaria"],
      ["monograma", "string", "Iniciales del logo"],
      ["color", "string (hex)", "Color principal de toda la app"],
      ["horarioApertura / horarioCierre", "number", "Define 'fuera de horario'"],
    ],
  },
];

export default function EsquemaDatos() {
  return (
    <div>
      <PageHeader
        titulo="Esquema de datos"
        descripcion="La forma de los datos de cada módulo. Toda la data de la demo vive en una capa mock (/src/data/mockData.js). Para conectar la base real de cada inmobiliaria, basta con devolver objetos con esta misma forma sin tocar la UI."
      />
      <Card className="p-4 rounded-lg border-slate-200 shadow-sm mb-6 bg-slate-50">
        <p className="text-sm text-slate-600">
          <span className="font-semibold text-slate-800">Cómo conectar una base real:</span> reemplazá las constantes exportadas (
          <code className="text-xs">PROPIEDADES</code>, <code className="text-xs">CONTRATOS</code>, <code className="text-xs">COBROS</code>…) por llamadas a tu API/DB que devuelvan los mismos tipos. Los componentes no cambian. Este esquema también está versionado en <code className="text-xs">/docs/esquema-datos.md</code>.
        </p>
      </Card>

      <div className="space-y-6">
        {MODULOS.map((m) => (
          <Card key={m.titulo} className="rounded-lg border-slate-200 shadow-sm overflow-hidden">
            <div className="px-5 py-4 border-b border-slate-100">
              <h3 className="text-base font-semibold text-slate-900 font-mono">{m.titulo}</h3>
              <p className="text-xs text-slate-500 mt-0.5">{m.nota}</p>
            </div>
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="bg-slate-50 text-left">
                    <th className="px-5 py-2 text-[11px] uppercase tracking-wide font-semibold text-slate-400">Campo</th>
                    <th className="px-5 py-2 text-[11px] uppercase tracking-wide font-semibold text-slate-400">Tipo</th>
                    <th className="px-5 py-2 text-[11px] uppercase tracking-wide font-semibold text-slate-400">Notas</th>
                  </tr>
                </thead>
                <tbody>
                  {m.campos.map((c, i) => (
                    <tr key={i} className="border-t border-slate-100">
                      <td className="px-5 py-2 font-mono text-xs text-slate-900">{c[0]}</td>
                      <td className="px-5 py-2 font-mono text-xs text-brand">{c[1]}</td>
                      <td className="px-5 py-2 text-slate-500 text-xs">{c[2]}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
